import React from 'react';
import PropTypes from 'prop-types';

export const HCPSignupWrapper = ({ children }) => (
  <div className="hcp-signup">
    {children}
  </div>
);

HCPSignupWrapper.propTypes = {
  children: PropTypes.any.isRequired,
};
